// $(function () {
//     var toggleClub = $('[js-club-toggle]'),
//         dropMenu = $('[js-club-drop-menu]');
//
//     toggleClub.on('click', function (e) {
//         e.stopPropagation();
//         dropMenu.toggleClass('club-toggle__drop-menu_active')
//     });
//
//     $('[js-club-toggle-select]').on('click', function (e) {
//         e.stopPropagation();
//         var club = $(this).data('club');
//
//           $('[js-club-toggle-current]').text(club);
//
//              dropMenu.removeClass('club-toggle__drop-menu_active');
//              dropMenu.prepend($(this));
//
//     });
//
//     $('body').on('click', function () {
//         dropMenu.removeClass('club-toggle__drop-menu_active')
//     })
// });